<template>
  <div class="setting_reset_password">
    <Form
      ref="formCustom"
      :model="formCustom"
      :rules="ruleCustom"
      :label-width="80"
      class="fromItem"
    >
      <FormItem label="旧密码" prop="oldPassword">
        <Input type="password" v-model="formCustom.oldPassword" />
      </FormItem>
      <FormItem label="新密码" prop="newPassword">
        <Input type="password" v-model="formCustom.newPassword" password />
      </FormItem>
      <FormItem label="确认密码" prop="passwdCheck">
        <Input type="password" v-model="formCustom.passwdCheck" password />
      </FormItem>
      <FormItem>
        <Button type="primary" @click="handleSubmit('formCustom')"
          >提 交</Button
        >
        <Button @click="handleReset('formCustom')" style="margin-left: 8px"
          >重 置</Button
        >
      </FormItem>
    </Form>
  </div>
</template>
<script>
export default {
  data() {
    //校验密码
    let patterPass = /^\S{6,}$/;
    const validatePass = (rule, value, callback) => {
      if (!patterPass.test(value)) {
        callback(new Error("请输入的旧密码，旧密码应为6位以上。"));
      } else {
        callback();
      }
    };
    const validateNewPass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入你的新密码。"));
      } else if (!patterPass.test(value)) {
        callback(new Error("新密码应为6位以上，请校正。"));
      } else if (
        this.formCustom.oldPassword !== "" &&
        this.formCustom.oldPassword === value
      ) {
        callback(new Error("新密码不应和旧密码一样。"));
      } else {
        if (this.formCustom.oldPassword !== "") {
          this.$refs.formCustom.validateField("passwdCheck");
        }
        callback();
      }
    };
    const validatePassCheck = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入新密码。"));
      } else if (value !== this.formCustom.newPassword) {
        callback(new Error("两次输入的新密码不匹配。"));
      } else {
        callback();
      }
    };
    return {
      formCustom: {
        oldPassword: "",
        passwdCheck: "",
        newPassword: ""
      },
      ruleCustom: {
        oldPassword: [{ validator: validatePass, trigger: "blur" }],
        newPassword: [{ validator: validateNewPass, trigger: "blur" }],
        passwdCheck: [{ validator: validatePassCheck, trigger: "blur" }]
      }
    };
  },
  methods: {
    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          delete this.formCustom.passwdCheck;
          this.putResetPasswordApi(this.formCustom);
        }
      });
    },
    //重置密码
    handleReset(name) {
      this.$refs[name].resetFields();
    },
    //请求重置密码
    putResetPasswordApi(data) {
      this.$axios.putResetPassword(data).then(res => {
        this.$Message.success(res.data.data);
        this.formCustom = {
          oldPassword: "",
          passwdCheck: "",
          newPassword: ""
        };
      });
    }
  }
};
</script>
<style lang="less" scoped>
.setting_reset_password {
  text-align: center;
  padding: 50px 0;
  width: 50%;
  .fromItem {
    min-width: 350px;
  }
}
</style>
